import { useCallback, useState } from 'react';

import { useSessionStorage } from './useSessionStorage';

type ValueSetter<T> = (storedValue: T) => void;

export function useSessionState<T>(
  key: string,
  initialValue?: T,
): [T | undefined, ValueSetter<T>] {
  const { getSessionStorageItem, setSessionStorageItem } = useSessionStorage<T>(
    key,
    initialValue,
  );

  const [storedValue, setStoredValue] = useState<T | undefined>(
    getSessionStorageItem(),
  );

  const setValue = useCallback(
    (value) => {
      setSessionStorageItem(value);
      setStoredValue(value);
    },
    [setSessionStorageItem],
  );
  return [storedValue, setValue];
}
